function endsWith(s, search) {
    if (!s || typeof s !== 'string' ||
        !search || typeof search !== 'string' ||
        s.length < search.length)
        return false
    let ss = s.substr(s.length - search.length);
    return ss == search;
}

export default endsWith